<template>
  <div class="home">
      <div class="container">
        <StorySlider :stories="response.stories"/>
        <ImageSlider :images="response.sliders" v-if="755 < screen" />
        <ImageSliderMobile :images="response.sliders" v-if="755 >= screen" />
      <div class="mt-3 mb-5">
        <h2 class="text-center my-3">دسته‌بندی‌ها</h2>
        <ShopCategory />
      </div>
      <div class="mt-3 mb-5" v-if="this.$route.query.mode != 'pwa'">
        <div class="bg-club">
          <div class="form-group p-5" dir="rtl">
            <p for="formGroupExampleInput" class="text-center club-label">نوراشاپ اپلیکیشنی برای خرید آسان</p>
            <p class="text-center">به کمک نرم افزار نورا شما می توانید خریدی آسانتر و دسترسی راحت تر به سفارشات خود داشته باشید.</p>
            <div class="club-input my-4 justify-content-center">
              <a href="/install-app" class="btn btn-secondary club-btn">نصب</a>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 mb-5">
        <MovingBrands />
      </div>
      <div class="mt-3 mb-5">
        <h2 class="text-center my-3"><router-link to="/off">موجودی محدود</router-link></h2>
        <ProductCarousel :objects="productsOff" more="/off"/>
      </div>
      <div class="mt-3 mb-5">
        <h2 class="text-center my-3">جدیدترین محصولات</h2>
        <ProductCarousel :objects="productsNew"/>
      </div>
      <div class="mt-3 mb-5">
        <h2 class="text-center my-3">پرطرفدار‌ها از دید کاربران</h2>
        <ProductCarousel :objects="products"/>
      </div>
      <div class="row mt-3 mb-5" v-if="videos && videos.length != 0">
        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
          <a :href="videos[0].link">
            <video class="video" muted playsinline autoplay loop>
              <source :src="$MEDIA + videos[0].file" type="video/mp4" class="">
            </video>
          </a>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
          <a :href="videos[1].link">
            <video class="video" muted playsinline autoplay loop>
              <source :src="$MEDIA + videos[1].file" type="video/mp4" class="">
            </video>
          </a>
        </div>
      </div>
      <div class="mt-3 mb-5">
        <h2 class="text-center my-4">دسته‌بندی‌ها</h2>
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation" :key="(category,index)" v-for="(category,index)  in $categories">
            <button :aria-label="category.name" class="nav-link" :class="index === 1 ? 'active' : ''" data-bs-toggle="tab" :data-bs-target="'#c'+index" type="button" role="tab">{{category.name}}</button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show" :class="index === 1 ? 'active' : ''" :id="'c'+index" role="tabpanel" :key="(category,index)" v-for="(category,index)  in $categories">
            <BrandCarousel :objects="category.brands"/>
            <ProductCarousel :objects="category.bestProducts" :more="'/category/' + category.slug" />
          </div>
        </div>
      </div>
      <div class="mt-3 mb-5">
        <CollectionCarousel :collections="collections" />
      </div>
      <div class="mt-3 mb-5">
        <h2 class="text-center my-4">نظر مشتریان</h2>
        <div class="row" dir="rtl">
          <CommentCarousel :objects="comments" v-if="comments"/>
        </div>
      </div>
      <div class="mt-3 mb-5">
        <h2 class="text-center my-4">دسته‌بندی مقالات</h2>
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation" :key="(category,index)" v-for="(category,index)  in $blogCategories">
            <button :aria-label="category.name" class="nav-link" :class="index === 1 ? 'active' : ''" data-bs-toggle="tab" :data-bs-target="'#b'+index" type="button" role="tab">{{category.name}}</button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show" :class="index === 1 ? 'active' : ''" :id="'b'+index" role="tabpanel" :key="(category,index)" v-for="(category,index)  in $blogCategories">
            <div class="row" dir="rtl">
              <BlogCarousel :objects="category.bestBlogs" />
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 mb-5">
        <div class="bg-club">
          <div class="form-group p-5" dir="rtl">
            <p for="formGroupExampleInput" class="text-center club-label">برای دریافت خبرها و تخفیف‌ها شماره همراه خود را وارد کنید.</p>
            <div class="club-input my-4">
              <input type="text" class="form-control without-border-radius" v-model="clubNumber" id="formGroupExampleInput" placeholder="شماره موبایل ...">
              <button aria-label="ثبت" @click="sendToClub(clubNumber)" type="button" class="btn btn-secondary club-btn right-input-btn">ثبت</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ImageSlider from '@/components/ImageSlider.vue'
import ImageSliderMobile from '@/components/ImageSliderMobile.vue'
import ShopCategory from '@/components/ShopCategory.vue'
import ProductCarousel from '@/components/ProductCarousel.vue'
import BrandCarousel from '@/components/BrandCarousel.vue'
import BlogCarousel from '@/components/BlogCarousel.vue'
import CommentCarousel from '@/components/CommentCarousel.vue'
import CollectionCarousel from '@/components/CollectionCarousel.vue'
import StorySlider from '@/components/StorySlider.vue'
import MovingBrands from '@/components/MovingBrands.vue'

export default {
  name: 'HomeView',
  components: {
    ImageSlider,
    ImageSliderMobile,
    ShopCategory,
    ProductCarousel,
    BrandCarousel,
    BlogCarousel,
    CommentCarousel,
    CollectionCarousel,
    StorySlider,
    MovingBrands
  },
  data () {
    return {
      response: {},
      products: null,
      clubNumber: '',
      videos: [],
      comments: [],
      productsNew: null,
      productsOff: null,
      collections: [],
      screen: screen.width
    }
  },
  mounted () {
    const query = `
{
  productsNew: products(
    filters: {count: 12, order: "-date_update", available: true}
  ) {
    id
    available
    slug
    name
    image: PNG
    mlActivation
    specialTag
    concepts:concepts{
      id
      price
      name
      video
      videoCover
      image
      description
    }
    isOffInt
    priceAfterOff
    priceBeforeOff
    categorySlug
    subCategorySlug
    categoryId
  }
  productsOff: products(
    filters: {count: 8, order: "shuffle", available: true, haveOff: true}
  ) {
    id
    available
    slug
    name
    image: PNG
    mlActivation
    specialTag
    concepts:concepts{
      id
      price
      name
      video
      videoCover
      image
      description
    }
    isOffInt
    priceAfterOff
    priceBeforeOff
    categorySlug
    subCategorySlug
    categoryId
  }
  products: shuffleCategory(count: 8) {
    id
    available
    slug
    name
    image: PNG
    mlActivation
    specialTag
    concepts:concepts{
      id
      price
      name
      video
      videoCover
      image
      description
    }
    isOffInt
    priceAfterOff
    priceBeforeOff
    categorySlug
    subCategorySlug
    categoryId
  }
  collections: collections(filters: {shuffle: "t"}) {
    slug
    description
    name
    image
  }
  comments: productComments(slug: "shuffle") {
    id
    productLink: productLink
    product{
      name
      PNG
    }
    rate
    text
    profile
    date
  }
  commentsMore: productCommentsMore(slug: "shuffle") {
    id
    productLink: productLink
    product{
      name
      PNG
    }
    rate
    text
    profile
    date
  }
  videos: videos(key: "Home") {
    link
    file
  }
  meta(key:"${this.$options.name}") {
    seoTitle
    seoKeyword
    seoDescription
  }
  sliders (key: "Home") {
    imageMobile
    image
    alt
    link
  }
  stories (key: "Home") {
    id
    videoCover
    link
    video
    prev
    next
  }
}
    `
    this.$fetchGraphQL(query)
      .then((response) => {
        this.response = response.data
        this.setMetaByObj(response.data.meta)
        this.collections = response.data.collections
        this.videos = response.data.videos
        this.comments = response.data.comments.concat(response.data.commentsMore)
        this.products = response.data.products
        this.productsNew = response.data.productsNew
        this.productsOff = response.data.productsOff
      })
  }
}
</script>

<style scoped>
.video{
  width: 100%;
  border-radius: 24px;
  box-shadow: 0 2px 5px 0 rgb(0 0 0 / 20%), 0 2px 10px 0 rgb(0 0 0 / 10%);
}
.nav-link{
  color: #bdbdbd;
}
.nav{
  justify-content: center;
}
.nav-link:hover{
  border-color: transparent;
}
.nav-item{
  filter: drop-shadow(0px 2px 5px rgba(50, 50, 0, 0.2));
  margin: 5px 0px;
}
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active{
  color: black;
  background-color: #e8acd4;
  border-color: transparent;
  clip-path: polygon(20% 0%, 100% 0%, 100% 50%, 100% 100%, 0% 100%, 0% 50%);
}
.nav-tabs{
  border:none;
}

.nav-link{
    border: solid #e8acd4 2px;
    color: black;
    padding: 6px 10px;
    border-radius: 24px;
    width: max-content;
    transition: 0.4s;
}
.nav-link:hover{
    background-color: #e8acd4;
    color: black;
    padding: 6px 13px;
    border-radius: 24px;
    width: max-content;
}
</style>
